import { Card, Grid } from '@mui/material';
import React, { useState } from 'react';
import DateTimeService from 'src/utils/DateTimeService';

import useQueryParams from 'src/hooks/useQueryParams';
import Filter from './Filter';
import PageHeader from '../_sub-components/PageHeader';
import ResultTable from './ResultTable';

function CumulativeDistanceReport() {
  const [filter, setFilter] = useQueryParams({});
  return (
    <Grid
      sx={{
        px: 4
      }}
      container
      direction="row"
      justifyContent="center"
      spacing={4}
    >
      <PageHeader
        heading="Cumulative Distance Report"
        subtitle="This report shows the cumulative distance travelled by each vehicle on a daily basis."
      />
      <Grid item xs={12} lg={3}>
        <Card>
          <Filter setFilter={setFilter} filter={filter} />
        </Card>
      </Grid>
      <Grid item xs={12} lg={9}>
        <Card>
          <ResultTable filter={filter} />
        </Card>
      </Grid>
    </Grid>
  );
}

export default CumulativeDistanceReport;
